(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anniversary-all-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ooakb-blue-topaz-pdp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.ooakb-btp');
    sections.forEach((section) => {
      if (section.dataset.enhanced === 'true') return;
      section.dataset.enhanced = 'true';
      const form = section.querySelector('[data-product-form]');
      const mainAdd = section.querySelector('[data-main-add]');
      const addLabel = section.querySelector('[data-add-label]');
      const select = section.querySelector('[data-variant-select]');
      const price = section.querySelector('[data-price]');
      const compare = section.querySelector('[data-compare-price]');
      const sticky = section.querySelector('[data-sticky-bar]');
      const stickyAdd = section.querySelector('[data-sticky-add]');
      const stickyPrice = section.querySelector('[data-sticky-price]');
      const stockLabel = section.querySelector('[data-stock-label]');
      const purchasePanel = section.querySelector('[data-purchase-panel]');
      const mediaTrack = section.querySelector('[data-media-track]');
      const mediaCurrent = section.querySelector('[data-media-current]');
      const storySticky = section.querySelector('[data-story-sticky]');

      const updateVariant = () => {
        if (!select) return;
        const option = select.options[select.selectedIndex];
        const available = option.dataset.available === 'true';
        price.textContent = option.dataset.price;
        stickyPrice.textContent = option.dataset.price;
        compare.textContent = option.dataset.compare || '';
        compare.classList.toggle('ooakb-btp__compare-price--hidden', !option.dataset.compare);
        mainAdd.disabled = !available;
        stickyAdd.disabled = !available;
        addLabel.textContent = available ? 'Add to cart' : 'Sold out';
        stickyAdd.textContent = available ? 'Add to cart' : 'Sold out';
        stockLabel.textContent = available ? 'In stock' : 'Sold out';
      };

      if (select) select.addEventListener('change', updateVariant);
      if (stickyAdd && form) stickyAdd.addEventListener('click', () => form.requestSubmit(mainAdd));

      if (mediaTrack && mediaCurrent) {
        const updateMediaCount = () => {
          const width = mediaTrack.clientWidth || 1;
          mediaCurrent.textContent = String(Math.round(mediaTrack.scrollLeft / width) + 1);
        };
        mediaTrack.addEventListener('scroll', updateMediaCount, { passive: true });
        window.addEventListener('resize', updateMediaCount, { passive: true });
        updateMediaCount();
      }

      if (sticky && purchasePanel && window.matchMedia('(max-width: 989px)').matches) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => { sticky.hidden = entry.isIntersecting; });
        }, { threshold: 0.12 });
        observer.observe(purchasePanel);
      }

      if (storySticky && window.matchMedia('(max-width: 989px)').matches) {
        const primaryForm = [...document.querySelectorAll('form[action*="/cart/add"]')]
          .find((candidate) => !section.contains(candidate));
        const purchaseArea = primaryForm?.closest('.product-information') || primaryForm;
        if (purchaseArea) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => { storySticky.hidden = entry.isIntersecting; });
          }, { threshold: 0.08 });
          observer.observe(purchaseArea);
        } else {
          storySticky.hidden = false;
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
